/*
 * Copyright (c) 2021, 2022 Tropyc Stoic (38c316a1b8d7188d059c273d892b723b)
 *
 * Permission to use, copy, modify, and distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
 * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
 * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
 * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
 * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
 * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { HashRouter, Routes, Route } from "react-router-dom"; //cannot use BrowserRouter on IPFS
import Create from "./routes/create";
import Exit from "./routes/exit";
import Metadata from "./routes/metadata";
import CreateStaking from "./routes/createstaking";
import Home from "./routes/home";
import Farm from "./routes/farm";
import AirdropPage from "./routes/airdrop";
import SourcePage from "./routes/source";

ReactDOM.render(
  <React.StrictMode>
    <HashRouter>
        <Routes>
            <Route path="/" element={<App />}>
                <Route index element={<Home />} />
                <Route path="create" element={<Create />} />
                <Route path="createstaking" element={<CreateStaking />} />
                <Route path="metadata" element={<Metadata />}>
                    <Route path=":tokenAddress" element={<Metadata />} />
                </Route>
                <Route path="farm" element={<Farm />}>
                    <Route path=":tokenAddress" element={<Farm />} />
                </Route>
                <Route path="burn" element={<Exit />} />
                <Route path="airdrop" element={<AirdropPage />} />
                <Route path="source" element={<SourcePage />} />
            </Route>
        </Routes>
    </HashRouter>
  </React.StrictMode>,
  document.getElementById('root')
);
